import { CvDialogButton } from './cv-dialog.types';

// Order matters: legacy's confirm reads Yes then No, its logout reads Cancel first.
export const DIALOG_BUTTONS = {
  OK_ONLY: [{ label: 'Ok', role: 'confirm' }],
  YES_ONLY: [{ label: 'Yes', role: 'confirm' }],
  LOG_OUT_ONLY: [{ label: 'Log Out', role: 'confirm' }],
  YES_NO: [
    { label: 'Yes', role: 'confirm' },
    { label: 'No', role: 'cancel' },
  ],
  CANCEL_YES: [
    { label: 'Cancel', role: 'cancel' },
    { label: 'Yes', role: 'confirm' },
  ],
  /** No way out: the dialog closes only when the condition behind it clears. */
  NO_BUTTONS: [],
} as const satisfies Record<string, readonly CvDialogButton[]>;

export type DialogButtonPreset = keyof typeof DIALOG_BUTTONS;
